import http from '@utils/http';

const CLIENTS_PAGE_LIMIT_MAX = 100;

/**
 * GET /api/v1/clients
 * Permission: clients.clients.view
 * @param {{
 *  page?: number,
 *  limit?: number,
 *  sortBy?: 'createdAt'|'email'|'name',
 *  sortOrder?: 'asc'|'desc',
 *  q?: string,
 *  type?: 'all'|'managed'|'in_house'
 * }} params
 */
export const getClients = (params = {}) => {
    const safeParams = { ...params, limit: Math.min(Number(params.limit) || 20, CLIENTS_PAGE_LIMIT_MAX) };
    return http.get('/clients', { params: safeParams }).then((res) => {
        const payload = res.data ?? {};
        const inner = payload.data ?? payload;
        const list = inner.items ?? inner.data ?? (Array.isArray(inner) ? inner : []);
        const data = Array.isArray(list) ? list : [];
        return {
            data,
            total: inner.total ?? payload.total ?? 0,
            page: inner.page ?? payload.page ?? 1,
            limit: inner.limit ?? payload.limit ?? safeParams.limit ?? 20,
            totalPages: inner.totalPages ?? payload.totalPages ?? 1,
        };
    });
};

/**
 * GET /api/v1/clients/:id
 * Permission: clients.clients.view
 * @param {string|number} id
 */
export const getClientById = (id) => {
    if (id == null || id === '') return Promise.reject(new Error('Client id is required'));
    return http.get(`/clients/${encodeURIComponent(String(id))}`).then((res) => {
        const payload = res.data ?? {};
        const inner = payload.data ?? payload;
        const data = inner.data ?? inner;
        return data ?? null;
    });
};

